module.exports = __webpack_public_path__ + "static/media/matilde-cap-brazil-angry.887c952b.png";